import { IconLogout } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import useLogout from "hooks/useLogout";

const LogoutButton = () => {
  const { t } = useTranslation("common");
  const { logout, isPending } = useLogout();

  return (
    <button
      data-testid="logout-button"
      disabled={isPending}
      onClick={logout}
      className="flex items-center gap-1 text-gray-light text-xs"
    >
      <span className="text-gray-dark font-[sans-serif]">{t("logout")}</span>
      <IconLogout className="text-blue-dark" />
    </button>
  );
};

export default LogoutButton;
